import React, { useState } from "react"
import { AiOutlineHeart } from "react-icons/ai"
import { BsCart2 } from "react-icons/bs"
import { motion } from "framer-motion"
import useGlobalContext from "../context/GlobalContext"
import useCartContext from "../context/CartContext"
import { useNavigate } from "react-router-dom"

export const slideImg = {
  show: {
    opacity: 1,
    scale: 1,
  },
  hide: {
    opacity: 0,
    scale: 0.5,
  },
}

const Slide = ({ slide }) => {
  const navigate = useNavigate()
  const { increaseCartQuantity } = useCartContext()
  const { changeCursor, setOpenCart, setOpenWishList } = useGlobalContext()

  const [isHover, setIsHover] = useState(false)

  const goToProduct = (e) => {
    e.preventDefault()
    navigate(`/product/${slide.id}`)
  }

  return (
    <div
      onClick={(e) => goToProduct(e)}
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
      className="slide"
      tabIndex={0}
    >
      <div className={`slide-img ${isHover ? "hovered" : ""}`}>
        <motion.img
          variants={slideImg}
          animate={!isHover ? "show" : "hide"}
          transition={{ duration: 0.25 }}
          src={slide.previews[0]}
          alt=""
        />
        <motion.img
          variants={slideImg}
          animate={isHover ? "show" : "hide"}
          transition={{ duration: 0.25 }}
          src={slide.previews[1]}
          alt=""
        />
        <div
          className="slide-icon-btns"
          onMouseEnter={() => changeCursor("")}
          onMouseLeave={() => changeCursor("drag")}
        >
          <button
            onClick={(e) => {
              e.preventDefault()
              e.stopPropagation()
              setOpenWishList(true)
            }}
            className="slide-icon-btn"
          >
            <AiOutlineHeart className="icon" />
          </button>
          <button
            className="slide-icon-btn"
            onClick={(e) => {
              e.preventDefault()
              e.stopPropagation()
              setOpenCart(true)
              increaseCartQuantity(slide.id)
            }}
            disabled={!slide.id}
          >
            <BsCart2 className="icon" />
          </button>
        </div>
      </div>
      <div className="slide-desc">
        <p className="slide-name">{slide.name}</p>
        <p className="slide-price">${slide.price}</p>
      </div>
    </div>
  )
}

export default Slide
